export enum Currency {
  PLN = 'PLN',
  EUR = 'EUR',
  USD = 'USD',
}
